module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"up":"наверх"},"en":{"up":"Up"}}')
  delete Component.options._Ctor
}
